import { LayoutComponent } from "@jelly/lesson";

import * as f100kr01 from "./linear/f-100-kr-01";
import * as f100kr1 from "./linear/f-100-kr-1";
import * as f100kr3 from "./linear/f-100-kr-3";
import * as f100kr4 from "./linear/f-100-kr-4";
import * as f100kr5 from "./linear/f-100-kr-5";
import * as f100kr6 from "./linear/f-100-kr-6";
import * as f100kr7 from "./linear/f-100-kr-7";
import * as f100kr8 from "./linear/f-100-kr-8";
import * as f100kr9 from "./linear/f-100-kr-9";
import * as f100kr10 from "./linear/f-100-kr-10";
import * as f200kr01 from "./linear/f-200-kr-01";
import * as f200kr1 from "./linear/f-200-kr-1";
import * as f200kr3 from "./linear/f-200-kr-3";
import * as f200kr4 from "./linear/f-200-kr-4";
import * as f200kr5 from "./linear/f-200-kr-5";
import * as f200kr6 from "./linear/f-200-kr-6";
import * as f200kr7 from "./linear/f-200-kr-7";
import * as f200kr8 from "./linear/f-200-kr-8";
import * as f200kr9 from "./linear/f-200-kr-9";
import * as f200kr10 from "./linear/f-200-kr-10";
import * as f300kr01 from "./linear/f-300-kr-01";
import * as f300kr1 from "./linear/f-300-kr-1";
import * as f300kr3 from "./linear/f-300-kr-3";
import * as f300kr4 from "./linear/f-300-kr-4";
import * as f300kr5 from "./linear/f-300-kr-5";
import * as f300kr6 from "./linear/f-300-kr-6";
import * as f300kr7 from "./linear/f-300-kr-7";
import * as f300kr8 from "./linear/f-300-kr-8";
import * as f300kr9 from "./linear/f-300-kr-9";
import * as f300kr10 from "./linear/f-300-kr-10";
import * as f400kr01 from "./linear/f-400-kr-01";
import * as f400kr1 from "./linear/f-400-kr-1";
import * as f400kr3 from "./linear/f-400-kr-3";
import * as f400kr4 from "./linear/f-400-kr-4";
import * as f400kr5 from "./linear/f-400-kr-5";
import * as f400kr6 from "./linear/f-400-kr-6";
import * as f400kr7 from "./linear/f-400-kr-7";
import * as f400kr8 from "./linear/f-400-kr-8";
import * as f400kr9 from "./linear/f-400-kr-9";
import * as f400kr10 from "./linear/f-400-kr-10";
import * as f500kr01 from "./linear/f-500-kr-01";
import * as f500kr1 from "./linear/f-500-kr-1";
import * as f500kr3 from "./linear/f-500-kr-3";
import * as f500kr4 from "./linear/f-500-kr-4";
import * as f500kr5 from "./linear/f-500-kr-5";
import * as f500kr6 from "./linear/f-500-kr-6";
import * as f500kr7 from "./linear/f-500-kr-7";
import * as f500kr8 from "./linear/f-500-kr-8";
import * as f500kr9 from "./linear/f-500-kr-9";
import * as f500kr10 from "./linear/f-500-kr-10";
import * as f750kr01 from "./linear/f-750-kr-01";
import * as f750kr1 from "./linear/f-750-kr-1";
import * as f750kr3 from "./linear/f-750-kr-3";
import * as f750kr4 from "./linear/f-750-kr-4";
import * as f750kr5 from "./linear/f-750-kr-5";
import * as f750kr6 from "./linear/f-750-kr-6";
import * as f750kr7 from "./linear/f-750-kr-7";
import * as f750kr8 from "./linear/f-750-kr-8";
import * as f750kr9 from "./linear/f-750-kr-9";
import * as f750kr10 from "./linear/f-750-kr-10";
import * as f1000kr01 from "./linear/f-1000-kr-01";
import * as f1000kr1 from "./linear/f-1000-kr-1";
import * as f1000kr3 from "./linear/f-1000-kr-3";
import * as f1000kr4 from "./linear/f-1000-kr-4";
import * as f1000kr5 from "./linear/f-1000-kr-5";
import * as f1000kr6 from "./linear/f-1000-kr-6";
import * as f1000kr7 from "./linear/f-1000-kr-7";
import * as f1000kr8 from "./linear/f-1000-kr-8";
import * as f1000kr9 from "./linear/f-1000-kr-9";
import * as f1000kr10 from "./linear/f-1000-kr-10";
import * as f1500kr01 from "./linear/f-1500-kr-01";
import * as f1500kr1 from "./linear/f-1500-kr-1";
import * as f1500kr3 from "./linear/f-1500-kr-3";
import * as f1500kr4 from "./linear/f-1500-kr-4";
import * as f1500kr5 from "./linear/f-1500-kr-5";
import * as f1500kr6 from "./linear/f-1500-kr-6";
import * as f1500kr7 from "./linear/f-1500-kr-7";
import * as f1500kr8 from "./linear/f-1500-kr-8";
import * as f1500kr9 from "./linear/f-1500-kr-9";
import * as f1500kr10 from "./linear/f-1500-kr-10";
import * as f2000kr01 from "./linear/f-2000-kr-01";
import * as f2000kr1 from "./linear/f-2000-kr-1";
import * as f2000kr3 from "./linear/f-2000-kr-3";
import * as f2000kr4 from "./linear/f-2000-kr-4";
import * as f2000kr5 from "./linear/f-2000-kr-5";
import * as f2000kr6 from "./linear/f-2000-kr-6";
import * as f2000kr7 from "./linear/f-2000-kr-7";
import * as f2000kr8 from "./linear/f-2000-kr-8";
import * as f2000kr9 from "./linear/f-2000-kr-9";
import * as f2000kr10 from "./linear/f-2000-kr-10";
import * as f5000kr01 from "./linear/f-5000-kr-01";
import * as f5000kr1 from "./linear/f-5000-kr-1";
import * as f5000kr3 from "./linear/f-5000-kr-3";
import * as f5000kr4 from "./linear/f-5000-kr-4";
import * as f5000kr5 from "./linear/f-5000-kr-5";
import * as f5000kr6 from "./linear/f-5000-kr-6";
import * as f5000kr7 from "./linear/f-5000-kr-7";
import * as f5000kr8 from "./linear/f-5000-kr-8";
import * as f5000kr9 from "./linear/f-5000-kr-9";
import * as f5000kr10 from "./linear/f-5000-kr-10";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        fullWidthControls: true,
        controls: [
          {
            type: "dropdown",
            options: {
              label: "Frequency",
            },
            items: [
              { name: "100 Hz" },
              { name: "200 Hz" },
              { name: "300 Hz" },
              { name: "400 Hz" },
              { name: "500 Hz" },
              { name: "750 Hz" },
              { name: "1000 Hz" },
              { name: "1500 Hz" },
              { name: "2000 Hz" },
              { name: "5000 Hz" },
            ],
          },
          {
            type: "dropdown",
            options: {
              label: "kR",
            },
            items: [
              { name: "0.1" },
              { name: "1" },
              { name: "3" },
              { name: "4" },
              { name: "5" },
              { name: "6" },
              { name: "7" },
              { name: "8" },
              { name: "9" },
              { name: "10" },
            ],
          },
        ],
        extraContent: [
          [
            f100kr01.extraContent,
            f100kr1.extraContent,
            f100kr3.extraContent,
            f100kr4.extraContent,
            f100kr5.extraContent,
            f100kr6.extraContent,
            f100kr7.extraContent,
            f100kr8.extraContent,
            f100kr9.extraContent,
            f100kr10.extraContent,
          ],
          [
            f200kr01.extraContent,
            f200kr1.extraContent,
            f200kr3.extraContent,
            f200kr4.extraContent,
            f200kr5.extraContent,
            f200kr6.extraContent,
            f200kr7.extraContent,
            f200kr8.extraContent,
            f200kr9.extraContent,
            f200kr10.extraContent,
          ],
          [
            f300kr01.extraContent,
            f300kr1.extraContent,
            f300kr3.extraContent,
            f300kr4.extraContent,
            f300kr5.extraContent,
            f300kr6.extraContent,
            f300kr7.extraContent,
            f300kr8.extraContent,
            f300kr9.extraContent,
            f300kr10.extraContent,
          ],
          [
            f400kr01.extraContent,
            f400kr1.extraContent,
            f400kr3.extraContent,
            f400kr4.extraContent,
            f400kr5.extraContent,
            f400kr6.extraContent,
            f400kr7.extraContent,
            f400kr8.extraContent,
            f400kr9.extraContent,
            f400kr10.extraContent,
          ],
          [
            f500kr01.extraContent,
            f500kr1.extraContent,
            f500kr3.extraContent,
            f500kr4.extraContent,
            f500kr5.extraContent,
            f500kr6.extraContent,
            f500kr7.extraContent,
            f500kr8.extraContent,
            f500kr9.extraContent,
            f500kr10.extraContent,
          ],
          [
            f750kr01.extraContent,
            f750kr1.extraContent,
            f750kr3.extraContent,
            f750kr4.extraContent,
            f750kr5.extraContent,
            f750kr6.extraContent,
            f750kr7.extraContent,
            f750kr8.extraContent,
            f750kr9.extraContent,
            f750kr10.extraContent,
          ],
          [
            f1000kr01.extraContent,
            f1000kr1.extraContent,
            f1000kr3.extraContent,
            f1000kr4.extraContent,
            f1000kr5.extraContent,
            f1000kr6.extraContent,
            f1000kr7.extraContent,
            f1000kr8.extraContent,
            f1000kr9.extraContent,
            f1000kr10.extraContent,
          ],
          [
            f1500kr01.extraContent,
            f1500kr1.extraContent,
            f1500kr3.extraContent,
            f1500kr4.extraContent,
            f1500kr5.extraContent,
            f1500kr6.extraContent,
            f1500kr7.extraContent,
            f1500kr8.extraContent,
            f1500kr9.extraContent,
            f1500kr10.extraContent,
          ],
          [
            f2000kr01.extraContent,
            f2000kr1.extraContent,
            f2000kr3.extraContent,
            f2000kr4.extraContent,
            f2000kr5.extraContent,
            f2000kr6.extraContent,
            f2000kr7.extraContent,
            f2000kr8.extraContent,
            f2000kr9.extraContent,
            f2000kr10.extraContent,
          ],
          [
            f5000kr01.extraContent,
            f5000kr1.extraContent,
            f5000kr3.extraContent,
            f5000kr4.extraContent,
            f5000kr5.extraContent,
            f5000kr6.extraContent,
            f5000kr7.extraContent,
            f5000kr8.extraContent,
            f5000kr9.extraContent,
            f5000kr10.extraContent,
          ],
        ],
        components: [
          [
            f100kr01.components,
            f100kr1.components,
            f100kr3.components,
            f100kr4.components,
            f100kr5.components,
            f100kr6.components,
            f100kr7.components,
            f100kr8.components,
            f100kr9.components,
            f100kr10.components,
          ],
          [
            f200kr01.components,
            f200kr1.components,
            f200kr3.components,
            f200kr4.components,
            f200kr5.components,
            f200kr6.components,
            f200kr7.components,
            f200kr8.components,
            f200kr9.components,
            f200kr10.components,
          ],
          [
            f300kr01.components,
            f300kr1.components,
            f300kr3.components,
            f300kr4.components,
            f300kr5.components,
            f300kr6.components,
            f300kr7.components,
            f300kr8.components,
            f300kr9.components,
            f300kr10.components,
          ],
          [
            f400kr01.components,
            f400kr1.components,
            f400kr3.components,
            f400kr4.components,
            f400kr5.components,
            f400kr6.components,
            f400kr7.components,
            f400kr8.components,
            f400kr9.components,
            f400kr10.components,
          ],
          [
            f500kr01.components,
            f500kr1.components,
            f500kr3.components,
            f500kr4.components,
            f500kr5.components,
            f500kr6.components,
            f500kr7.components,
            f500kr8.components,
            f500kr9.components,
            f500kr10.components,
          ],
          [
            f750kr01.components,
            f750kr1.components,
            f750kr3.components,
            f750kr4.components,
            f750kr5.components,
            f750kr6.components,
            f750kr7.components,
            f750kr8.components,
            f750kr9.components,
            f750kr10.components,
          ],
          [
            f1000kr01.components,
            f1000kr1.components,
            f1000kr3.components,
            f1000kr4.components,
            f1000kr5.components,
            f1000kr6.components,
            f1000kr7.components,
            f1000kr8.components,
            f1000kr9.components,
            f1000kr10.components,
          ],
          [
            f1500kr01.components,
            f1500kr1.components,
            f1500kr3.components,
            f1500kr4.components,
            f1500kr5.components,
            f1500kr6.components,
            f1500kr7.components,
            f1500kr8.components,
            f1500kr9.components,
            f1500kr10.components,
          ],
          [
            f2000kr01.components,
            f2000kr1.components,
            f2000kr3.components,
            f2000kr4.components,
            f2000kr5.components,
            f2000kr6.components,
            f2000kr7.components,
            f2000kr8.components,
            f2000kr9.components,
            f2000kr10.components,
          ],
          [
            f5000kr01.components,
            f5000kr1.components,
            f5000kr3.components,
            f5000kr4.components,
            f5000kr5.components,
            f5000kr6.components,
            f5000kr7.components,
            f5000kr8.components,
            f5000kr9.components,
            f5000kr10.components,
          ],
        ],
      },
    },
  },
];

export default components;
